export default function convertToLocalTime(isoString) {
    const date = new Date(isoString);
    
    // Format options
    const options = {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit', // remove this line if you want "07:30 AM"
        hour12: true
    };

    return date.toLocaleTimeString(undefined, options);
}
